<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/training',
          title: 'Training'
        },
        {
          href: '/training/schedule',
          title: 'Classes & Workshops'
        }
      ]"
      :value="schedulePage.hero_section"
    >
      <template v-if="schedulePage.hero_section.cta" #cta>
        <HeroCta :value="schedulePage.hero_section.cta" />
      </template>
    </HeroSection>

    <v-lazy>
      <OccasionsSection
        :banner="banner"
        :filters-value="filtersValue"
        :show-embed-code="showEmbedCode"
        :show-past="showPast"
        :value="schedulePage.classes_section"
        :what-items="
          filtersValue.what && filtersValue.what.split(',').length > 1
            ? [
                {
                  title: `Products: ${filtersValue.what.replaceAll(',', ', ')}`,
                  value: filtersValue.what
                }
              ]
            : undefined
        "
        :what-menu="whatMenu"
        class="mb-16 hero-section hero-below-offset"
        main
      />
    </v-lazy>

    <DividerSection class="mb-16" />

    <ContactCtaSection
      :value="schedulePage.contact_cta_section"
      class="mb-16"
    />
  </div>
</template>

<script setup lang="ts">
import type { components } from '#root/types/directus'
import type {
  ClassesSection,
  ContactCtaSection,
  HeroSection
} from '#root/types/common'
import { onBeforeMount, ref } from 'vue'
import { useProvideDeliveryMethodsStore } from '#root/lib/useDeliveryMethodsStore'
import { useProvideTrainerPersonsStore } from '#root/lib/useTrainerPersonsStore'

const props = defineProps<{
  banner?: components['schemas']['ItemsBanners']
  deliveryMethods: components['schemas']['ItemsDeliveryMethods'][]
  schedulePage: {
    classes_section: ClassesSection
    contact_cta_section: ContactCtaSection
    hero_section: HeroSection
  }
  trainers: components['schemas']['ItemsPersons'][]
  whatMenu: components['schemas']['ItemsMenus']
}>()

const filtersValue = ref<{
  deliveryMethod?: string
  what?: string
  who?: string
}>({})
const showEmbedCode = ref(false)
const showPast = ref(false)

useProvideDeliveryMethodsStore(props.deliveryMethods)
useProvideTrainerPersonsStore(props.trainers)

onBeforeMount(() => {
  const url = new URL(window.location.href)
  const deliveryMethod = url.searchParams.get('deliveryMethod')
  const what = url.searchParams.get('what')
  const who = url.searchParams.get('who')

  filtersValue.value = {
    ...(deliveryMethod
      ? { deliveryMethod: deliveryMethod.toUpperCase() }
      : undefined),
    ...(what ? { what: what.toUpperCase() } : undefined),
    ...(who ? { who: who.toUpperCase() } : undefined)
  }
  showEmbedCode.value = url.searchParams.get('showEmbedCode') === 'true'
  showPast.value = url.searchParams.get('showPast') === 'true'
})
</script>
